import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import { ApiContext } from './App';

function Login({ setToken }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(''); // State for error message
  const BASE_URL = useContext(ApiContext);

  const login = async () => {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    try {
      const response = await fetch(`${BASE_URL}/v1/token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString()
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Login failed", response.status, errorData.detail);
        setErrorMessage(errorData.detail || "Login failed. Please try again.");
        return;
      }

      const data = await response.json();
      if (data.access_token) {
        setToken(data.access_token);
        localStorage.setItem('token', data.access_token);
        setErrorMessage('');
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden', // Prevent unnecessary scroll bars
        backgroundColor: (theme) => theme.palette.background.default,
        color: (theme) => theme.palette.text.primary,
      }}
    >
      {/* Main content with flexGrow to push footer to the bottom */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center', // Centers vertically within the main content
          padding: 0,
        }}
      >
        {/* Logo and Name Image */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 0,
            my: 2,
          }}
        >
          <img src="icon-4.png" alt="Dice Icon" style={{ maxWidth: '120px', marginBottom: 1 }} />
          <img src="name-1.png" alt="gamemaster.chat" style={{ maxWidth: '300px' }} />
        </Box>

        {/* Login Form */}
        <Paper
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: '100%',
            maxWidth: '300px',
            elevation: 3,
            boxShadow: 3,
            borderRadius: 2,
            padding: 2,
            m: 0
          }}
        >
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={login}
            fullWidth
            sx={{ my: 1 }}
          >
            Login
          </Button>
          {/* Display error message if present */}

          <Typography
            fontSize={12}
            color={errorMessage ? 'error' : 'text.secondary'}
            sx={{
              m: 0,
              p: 0,
              textAlign: 'center',
              fontStyle: !errorMessage ? 'italic' : 'normal',
              opacity: !errorMessage ? 0 : 1,
              animation: !errorMessage ? 'fadeIn 2s ease-out forwards' : 'none',
              animationDelay: !errorMessage ? '0.5s' : '0s',
              '@keyframes fadeIn': {
                to: { opacity: 1 }
              }
            }}
          >
            {errorMessage || "Limitless adventure awaits!"}
          </Typography>

        </Paper>


        {/* Alpha Notice */}
        <Box sx={{ width: '100%', maxWidth: '300px', my: 1, p: 0 }}>
          <Alert severity="info" sx={{ mt: 2, fontSize: 13 }}>
            Currently in <strong>closed alpha</strong> testing. Visit <a href="https://gamemaster.chat" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>gamemaster.chat</a> for news and access.
          </Alert>
        </Box>


        {/* Footer positioned at the very bottom */}
        <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
          © 2025 gamemaster.chat. All rights reserved.
        </Typography>

      </Box>



    </Box >
  );
}

export default Login;
